import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { EventType, type EventMessage, type AuthenticationResult } from "@azure/msal-browser";
import { msalInstance } from "./auth/authConfig";
import { App } from "./App";
import "./styles/global.css";

// Setea la cuenta activa apenas hay un login exitoso — sin esto,
// getActiveAccount() puede devolver null incluso con una sesión válida.
msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const result = event.payload as AuthenticationResult;
    if (result.account) {
      msalInstance.setActiveAccount(result.account);
    }
  }
});

async function bootstrap() {
  await msalInstance.initialize();

  // Si ya hay una cuenta en cache (ej. refresh de página), usarla como activa.
  const existing = msalInstance.getAllAccounts();
  if (existing.length > 0 && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(existing[0]);
  }

  await msalInstance.handleRedirectPromise();

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>
  );
}

bootstrap();
